import type { OfferSectionProps } from "@/components/offer/offerDocumentTypes";
import { OfferEditableWrap } from "@/components/ClientOfferView";
import { DEFAULT_OFFER_TEXTS } from "@/lib/offerDocumentDefaults";
import styles from "@/components/ClientOfferView.module.css";

export function TimelineSection({ offerData }: OfferSectionProps) {
  const value =
    offerData.offerTexts?.timelineNote?.trim() || DEFAULT_OFFER_TEXTS.timelineNote;
  const onChange = offerData.onOfferTextsChange;
  if (!value) return null;

  return (
    <section className={styles.assumptions}>
      <div>
        <h2 className={styles.assumptionsHeading}>
          Harmonogram
          <br />
          orientacyjny
        </h2>
      </div>
      <div>
        {onChange ? (
          <OfferEditableWrap enabled>
            <p
              className={styles.timelineText}
              contentEditable
              suppressContentEditableWarning
              onBlur={(e) =>
                onChange({
                  timelineNote: e.currentTarget.textContent?.trim() ?? "",
                })
              }
            >
              {value}
            </p>
          </OfferEditableWrap>
        ) : (
          <p className={styles.timelineText}>{value}</p>
        )}
      </div>
    </section>
  );
}
